import { render, staticRenderFns } from "./space-file.vue?vue&type=template&id=741a3d9d&"
import script from "./space-file.vue?vue&type=script&lang=ts&"
export * from "./space-file.vue?vue&type=script&lang=ts&"
import style0 from "./space-file.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports